import React, { useContext } from "react";
import { Button, Card, Table, Tag, Typography, Tooltip, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import api from "Common/Client/Interceptor";
import useServerPagination from "Common/hooks/useServerPagination";
const { Text } = Typography

// Fetch a page of the mentor's assigned training groups.
const fetchAssignedGroups = async ({ pageNumber, pageSize, orderByLatest }) => {
  const mentorId = localStorage.getItem("personalId");
  const response = await api.get("/TrainingGroup/Mentor/List", {
    params: { MentorId: mentorId, pageNumber, pageSize, orderByLatest },
  });
  return response.data;
};

const AssignedTrainings = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const navigate = useNavigate();
  const { items, loading, paginationProps } = useServerPagination(fetchAssignedGroups, {}, {
    onError: (err) => message.error(err?.message || "Failed to load assigned groups"),
  });
  const columns = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      render: (text, record) => (
        <div style={{ position: "relative", display: "flex", alignItems: "center", }}>
          <Text strong>{text}</Text>
          {record.isRetryTraining && (
            <Tag color="orange" style={{ marginLeft: 8, fontWeight: "bold" }}>Repeated</Tag>
          )}
        </div>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Members Count",
      dataIndex: "membersCount",
      key: "membersCount",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" onClick={() => navigate(`/assigned-group-detail/${record.id}`)}>
          View Detail
        </Button>
      ),
    },
  ];
  return (
    <Card
      title="Assigned Groups (For Trainings)"
      className="card-professional"
      loading={loading}
    >
      <>
        <Tooltip title={isBlocked ? "Complete your profile first" : ""}>
          <Table columns={columns} dataSource={items} rowKey="id" pagination={paginationProps}
            scroll={{ x: "max-content" }}
            style={{ opacity: isBlocked ? 0.6 : 1, pointerEvents: isBlocked ? "none" : "auto" }} />
        </Tooltip>
      </>
    </Card>
  );
};
export default AssignedTrainings;
